import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFirestore } from "angularfire2/firestore";
import * as firebase from "firebase/app";
import { Observable } from "rxjs/Observable";
import { IReserve } from "../shared/models/reserve.model";
import { HistoryData } from "./history";

@Injectable()
export class ReserveData {
  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private afstore: AngularFirestore,
    private historyData: HistoryData,
  ) { }

  public createOrUpdateReserve(
    client: string,
    booking: IReserve,
  ) {
    // TODO: ESTA VUELTA YA NO VA CON EL NUEVO MODELO DE RESERVAS
    // if (booking.id === "") {
    //   booking.id = this.afDb.createPushId();
    //   this.action = "create";
    // } else {
    //   this.action = "update";
    // }

    // return new Promise((resolve, reject) => {
    //   return this.afDb.database
    //     .ref(`Clients/${client}/Reserves/${booking.id}`)
    //     .update(booking)
    //     .then(() => {
    //       this.historyData.set(
    //         `Reserve content`,
    //         "reserve",
    //         this.action,
    //         booking,
    //       );
    //       resolve(booking);
    //     })
    //     .catch((error) => {
    //       reject(error);
    //     });
    // });
  }

  public getReservesByClientIdAll(client: string): Observable<IReserve[]> {
    return this.afDb
      .list<IReserve>(`Clients/${client}/Reserves`)
      .valueChanges();
  }

  public getReservesObj(clientId: string) {
    return this.afDb.object<any>(`/Clients/${clientId}/UserReserves`).valueChanges();
  }

  public getUsersReserveByClient(clientId: string, objectId: string): Observable<any[]> {
    return this.afDb.list<any>(`Clients/${clientId}/ReservePrivacyPrivate/${objectId}`)
      .valueChanges();
  }

  public deleteReserveByClient(clientId: string, objectId: string, codeId: string): Promise<any> {
    return this.afDb.database
      .ref(`Clients/${clientId}/ReservePrivacyPrivate/${objectId}/${codeId}`)
      .remove();
  }

  public setUsersReserveByClient(clientId: string, objectId: string, users: any): Promise<any> {
    return this.afDb.database
      .ref(`Clients/${clientId}/ReservePrivacyPrivate/${objectId}`)
      .remove()
      .then(() =>
        this.afDb.database
          .ref(`Clients/${clientId}/ReservePrivacyPrivate/${objectId}`)
          .update(users));
  }

  public getReservesByClientId(client: string): Observable<IReserve[]> {
    return this.afDb
      .list<IReserve>(`Clients/${client}/Reserves`, (ref) => ref.orderByChild("state").equalTo(true))
      .valueChanges();
  }

  public getReserveById(
    client: string,
    reserveId: string,
  ): Observable<IReserve> {
    return this.afDb
      .object<IReserve>(`Clients/${client}/Reserves/${reserveId}`)
      .valueChanges();
  }

}



// WEBPACK FOOTER //
// ./src/providers/reserve.ts